import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
}));

const toOrdinal = (number) => {
  const ordinalRules = new Intl.PluralRules('en', {
    type: 'ordinal',
  });
  const suffixes = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
  };
  const suffix = suffixes[ordinalRules.select(number)];
  return number + suffix;
};

const QuarterSelect = ({
  labelId,
  id,
  defaultValue = 1,
  name,
  onChange = () => {},
  showAllQuarters = false,
  ...restPasthrough
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [quarter, setQuarter] = React.useState(1);
  const [quarters] = React.useState([1, 2, 3, 4]);

  const handleChange = (event) => {
    setQuarter(event.target.value);
    onChange(event);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (defaultValue) {
      setQuarter(defaultValue);
    }
  }, [defaultValue, quarters]);

  return (
    <Select
      labelId={labelId}
      id={id}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      value={quarter}
      onChange={handleChange}
      className={classes.formControl}
      name={name}
      {...restPasthrough}
    >
      {showAllQuarters ? (
        <MenuItem key={-1} value={-1}>
          All Quarters
        </MenuItem>
      ) : null}
      {quarters.map((quarter) => (
        <MenuItem key={quarter} value={quarter}>
          {toOrdinal(quarter)} Quarter
        </MenuItem>
      ))}
    </Select>
  );
};

export default QuarterSelect;
